window.addEventListener("load", function() {
    const svgContainers = document.querySelectorAll(".svg-container");

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Load SVG when it enters the viewport
                loadSVG(entry.target);
                observer.unobserve(entry.target);
            }
        });
    });

    svgContainers.forEach(container => {
        observer.observe(container);
    });

    const promiseCache = {}; // Cache for storing loaded SVG promises

    function loadSVG(container) {
        const svgSrc = container.getAttribute("data-src");
        const classList = Array.from(container.classList).filter(className => className !== "svg-container"); // Remove "svg-container" class

        // Check if SVG content is already cached
        if (promiseCache[svgSrc]) {
            promiseCache[svgSrc].then(svgContent => {
                // Ensure we have content before attempting to access it, in case of a failed load
                if (svgContent) {
                    const svgElement = svgContent.cloneNode(true);
                    svgElement.classList.add(...classList);
                    container.replaceWith(svgElement); // Replace the container with the cached SVG
                }
            });
            return;
        }

        // If not cached, fetch SVG content
        const fetchPromise = fetch(svgSrc)
            .then(response => {
                if (response.ok) {
                    return response.text();
                }

                throw new Error(`Failed to load SVG`);
            })
            .then(svgText => {
                const svgElement = new DOMParser().parseFromString(svgText, "image/svg+xml").documentElement;
                svgElement.classList.add(...classList);
                return svgElement;
            })
            .catch(error => {
                return null;
            });

        // Cache the fetch promise
        promiseCache[svgSrc] = fetchPromise;

        // Once SVG content is loaded, replace the container
        fetchPromise.then(svgElement => {
            if (svgElement) {
                container.replaceWith(svgElement); // Replace the container with the loaded SVG
            }
        });
    }
});